class NotificationRequest {
  static readNotifications = {
    notificationRecipient: null
  };
  static updateStatus = {
    notificationId: ""
  };
}
